import { useStore, createStore } from 'zustand';
import { GeneralPasswordStrength } from '@mews-commander/data-access';

interface PublicStore {
    passwordStrength: GeneralPasswordStrength | null;
    suggestPasskeySetup: boolean;
    setPasswordStrength: (passwordStrength: GeneralPasswordStrength | null) => void;
    setSuggestPasskeySetup: (suggestPasskeySetup: boolean) => void;
}

const publicStore = createStore<PublicStore>((set) => ({
    passwordStrength: null,
    setPasswordStrength: (passwordStrength) => set({ passwordStrength }),
    suggestPasskeySetup: false,
    setSuggestPasskeySetup: (suggestPasskeySetup) => set({ suggestPasskeySetup }),
}));

export const { setPasswordStrength, setSuggestPasskeySetup } = publicStore.getState();

export const usePublicStore = () => useStore(publicStore);

export const usePasswordStrength = () => usePublicStore().passwordStrength;
export const useSuggestPasskeySetup = () => usePublicStore().suggestPasskeySetup;
